import { ThunkDispatch, AnyAction } from 'store/store';
import { showNotificationAsync } from './thunks';
import { NotifyableAction } from 'notification/NotificationState';
import { PortfolioActionType } from 'portfolio/store/actions';
import { hideAllNotificationsAction } from './actions';
import { MiddlewareAPI } from 'redux';
import State from 'store/State';

export const notificationsMiddleware = () => [
    actionToNotificationMiddleware(),
    dismissNotificationsOnSelectionChangedMiddleware(),
];

export function actionToNotificationMiddleware() {
    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            next(action);

            const notifyableAction = action as unknown as NotifyableAction;
            if (!isNotifyableAction(notifyableAction)) {
                return;
            }

            const { message, type, title } = notifyableAction!.notification;

            middlewareAPI.dispatch(showNotificationAsync(message, type, title));
        };
}

export function dismissNotificationsOnSelectionChangedMiddleware() {
    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            next(action);

            if (action.type === PortfolioActionType.PORTFOLIO_SET_SELECTION) {
                middlewareAPI.dispatch(hideAllNotificationsAction());
            }
        };
}
function isNotifyableAction(action: NotifyableAction) {
    return (
        action.notification &&
        action.notification.message &&
        action.notification.type
    );
}
